// extracted by mini-css-extract-plugin
export var tag_container = "index-module--tag_container--4e1e3";